export default __webpack_public_path__ + "static/media/Attendence.2f2a48f7.svg";